<template>
  <tr
    class="hover:bg-gray-200 text-sm text-gray-700"
    :class="{ 'cursor-pointer': !(user.profesor === '1' && selectedTab === 5) }"
    @click.stop.prevent="showEntryModal(entry)"
  >
    <td
      v-if="selectedTab !== 6 && selectedTab !== 7"
      class="py-4 px-6 border-b border-gray-200 text-center"
    >
      <input
        type="checkbox"
        :value="entry"
        v-model="checkedEntries"
        @click.stop=""
        class="form-checkbox w-5 h-5 border-gray-700 text-orange-400 focus:shadow-none focus:border-current"
      />
    </td>
    <td
      v-for="(header, index) in currentTab.headers"
      :key="index"
      class="py-4 px-6 border-b border-gray-200"
      :class="{ 'text-center': header.field.name !== 'changes' }"
    >
      <template v-if="header.field.name === 'forma_de_pago'">
        {{ entry[header.field.name] | paymentMethod }}
      </template>
      <template v-else-if="header.field.type === 'date'">
        {{ entry[header.field.name] | localeDate }}
      </template>
      <div
        v-else-if="header.field.name === 'profesores'"
        class="flex flex-wrap"
      >
        <span
          v-for="(profesor, index) in splitProfesors(entry[header.field.name])"
          :key="index"
          class="block py-1 px-2 mb-1 mr-1 no-underline rounded-full bg-blue-600 text-white font-sans font-semibold text-xs border-blue btn-primary"
          >{{ profesor }}</span
        >
      </div>
      <template
        v-else-if="
          currentTab.title === 'Compras' &&
          header.field.name === 'ID_Alumno' &&
          entry[header.field.name] === null
        "
      >
        <i class="fas fa-exclamation-triangle text-orange-400"></i>
      </template>
      <template v-else>
        {{ entry[header.field.name] }}
      </template>
    </td>
    <td
      v-if="currentTabHasOptions"
      class="w-12 py-4 px-6 border-b border-gray-200"
    >
      <Dropdown :entry="entry" />
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import Dropdown from "@/components/Dropdown";
import EditEntry from "@/components/EditEntry";

export default {
  components: {
    Dropdown,
  },
  props: {
    entry: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["selectedTab", "user"]),
    ...mapGetters(["currentTab", "currentTabHasOptions"]),
    checkedEntries: {
      set(entries) {
        this.$store.state.checkedEntries = entries;
      },
      get() {
        return this.$store.state.checkedEntries;
      },
    },
  },
  methods: {
    ...mapActions(["deleteEntry"]),
    ...mapMutations(["showModal"]),
    showEntryModal(entry) {
      if (this.user.profesor === "1" && this.selectedTab === 5) return;

      this.showModal({
        component: EditEntry,
        title: "Editar entrada",
        props: {
          entry,
        },
      });
    },
    splitProfesors(profesors) {
      if (profesors === "" || profesors === null) {
        return "";
      }

      return profesors.split(",");
    },
  },
  filters: {
    paymentMethod(value) {
      switch (value) {
        case "1":
          return "Transferencia";
        case "2":
          return "Tarjeta";
        case "4":
          return "Financiado";
      }
    },
    localeDate(value) {
      const date = new Date(value.replace(/-/g, "/"));

      return Number.isNaN(date.getTime()) ? "" : date.toLocaleString("es-ES");
    },
  },
};
</script>
